module.exports = __webpack_public_path__ + "static/sw-185c1a01fbbb4ae9ae2021ccccfcbb67.png";